import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemVialCenticoreTearsFull extends Item {
    constructor() {
        super(definitions.ITEM_ID.VIAL_CENTICORE_TEARS_FULL, texture("prop_the_vial_of_tears_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}